import {Button, Checkbox, Form, Input, Select, message} from 'antd';
import PropTypes from 'prop-types';

const ContactUs = ({data}) => {
  const [form] = Form.useForm();

  const {Option} = Select;
  const {TextArea} = Input;

  const buildTemplates = values => {
    let lines = ['Hello Sobin, I submitted an enquiry.'];

    if (values.fullName) { lines.push(`Name: ${values.fullName}`); }
    if (values.phone) {   lines.push(`Phone: ${values.phone}`);  }
    if (values.email) {  lines.push(`Email: ${values.email}`); }
    if (values.city) {  lines.push(`City: ${values.city}`); }
    if (values.projectType) {  lines.push(`Project Type: ${values.projectType}`);}
    if (values.area) {  lines.push(`Area: ${values.area}`);  }
    if (values.scope?.length) {  lines.push(`Scope: ${values.scope.join(', ')}`);}
    if (values.budget) {  lines.push(`Budget: ${values.budget}`);}
    if (values.timeline) { lines.push(`Timeline: ${values.timeline}`);}
    if (values.message) { lines.push(`Message: ${values.message}`);}

    lines.push('Please contact me. Thanks!');

    const template = lines.join('\n');
    const waText = encodeURIComponent(template);

    return `https://wa.me/${data.WA_NUMBER}?text=${waText}`;
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const whatsappLink = buildTemplates(values);
      window.open(whatsappLink, '_blank');
      message.success('Redirecting to WhatsApp...');
    } catch (error) {
      console.log('Validation failed:', error);
    }
  };

  return (
    <div className={'w-full flex justify-center items-center bg-primary-950'}>
      <div className={'p-4 max-w-6xl'}>
        <div className={'rounded-3xl '}>
          <div className={'flex md:flex-row flex-col justify-center rounded-3xl overflow-hidden'}>
            <div className={'md:h-auto h-64 w-full'}>
              <img
                src={data.image}
                alt={'image1'}
                className={'w-full h-full object-cover'}
              />
            </div>

            <div className={'flex flex-col w-full'}>
              <Form
                form={form}
                layout={'vertical'}
                onFinish={handleSubmit}
                className={'bg-primary-300 p-5'}
              >
                <h1 className={'lg:text-5xl text-3xl font-bold mb-6 playfair-display-medium text-secondary-300 text-center'}>
                  {data.title}
                </h1>
                <div className={'flex gap-2'}>
                  <Form.Item
                    label={'Full Name'}
                    name={'fullName'}
                    className={'lg:w-1/2 w-full '}
                    rules={[{required: true, message: 'Please enter your full name'}]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={'Phone'}
                    name={'phone'}
                    className={'lg:w-1/2 w-full'}
                    rules={[
                      {required: true, message: 'Please enter your phone number'},
                      {
                        pattern: /^[6-9]\d{9}$/,
                        message: 'Please enter a valid 10-digit Indian phone number',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </div>

                <div className={'flex  gap-2'}>
                  <Form.Item label={'Email'} name={'email'}
                    className={'lg:w-1/2 w-full'}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item label={'City/Location'} name={'city'}
                    className={'lg:w-1/2 w-full'}
                  >
                    <Input />
                  </Form.Item>
                </div>

                <div className={'flex gap-2'}>
                  <Form.Item label={'Project Type'} name={'projectType'} className={'w-1/2'}>
                    <Select>
                      {data.projectTypes.map(option => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label={'Approx. Area (sq.ft)'}
                    name={'area'}
                    className={'w-1/2'}
                  >
                    <Input />
                  </Form.Item>
                </div>

                <Form.Item label={'Scope'} name={'scope'}>
                  <Checkbox.Group
                    options={data.scopeOptions.map(o => ({
                      label: o.label,
                      value: o.value,
                    }))}
                  />
                </Form.Item>

                <div className={'flex gap-2'}>
                  <Form.Item label={'Estimated Budget'} name={'budget'} className={'w-1/2'}>
                    <Select>
                      {data.budgetOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label={'Timeline'} name={'timeline'} className={'w-1/2'}>
                    <Select>
                      {data.timelineOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <Form.Item label={'Message / Requirements'} name={'message'}>
                  <TextArea rows={4} />
                </Form.Item>
                <Form.Item className={'flex justify-center'}>
                  <Button type={'primary'} htmlType={'submit'} className={'w-36'}>
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ContactUs.propTypes = {
  data: PropTypes.shape,
};

export default ContactUs;
